import mockData from '../../../features/widget-series-comparison/fixtures/data.json';

export default function* generator() {
    yield mockData;
}
